import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-video-downloader-content-benefits-section-option-0-title:Effortless and intuitive`,
    value: $localize`:@@page-video-downloader-content-benefits-section-option-0-value:The process is simple: copy the link of the Instagram video, paste it into our tool, and you’re all set! Our Instagram video downloader makes it easy for anyone to save videos with no technical skills required.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-benefits-section-option-1-title:No sign-up necessary`,
    value: $localize`:@@page-video-downloader-content-benefits-section-option-1-value:Skip the tedious account creation process. With our tool, you don’t need to log in or register. We value your privacy, making it effortless to save and download Instagram videos instantly.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-benefits-section-option-2-title:High-resolution video downloads`,
    value: $localize`:@@page-video-downloader-content-benefits-section-option-2-value:The videos you download keep their original quality. Whether a high-definition video or standard resolution, our Instagram downloader ensures the best possible quality is preserved.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-benefits-section-option-3-title:Immediate access to downloads`,
    value: $localize`:@@page-video-downloader-content-benefits-section-option-3-value:There’s no need to wait! Once you hit the download button, your video is ready in seconds, ensuring you can enjoy your content without delays.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-benefits-section-option-4-title:Bulk video downloads`,
    value: $localize`:@@page-video-downloader-content-benefits-section-option-4-value:Need to download several videos at once? Our tool allows you to grab multiple Instagram videos in one go, which is perfect for those who need to save a lot of content quickly.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-video-downloader-content-benefits-section-title:Why choose our Instagram video downloader?`,
  benefits: benefitDTOs,
};
